import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionSportEffects } from './competition-sport.effects'
import * as fromCompetitionSport from './competition-sport.reducer'
import { CompetitionSportSerializer } from './competition-sport.serializer'
import { CompetitionSportService } from './competition-sport.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionSport.FEATURE_NAME,
      fromCompetitionSport.competitionSportReducer
    ),
    EffectsModule.forFeature([CompetitionSportEffects])
  ],
  providers: [
    CompetitionSportService,
    {
      provide: CompetitionSportSerializer,
      useClass: CompetitionSportSerializer
    }
  ],
  declarations: []
})
export class CompetitionSportModule {}
